<template>
    <div>
      <b-container fluid class="px-0 pb-6 pb-8 pt-5 pt-md-6 bordes">
        <!-- <b-row>
          <div class="card-body text-left  p-0">              
              <b-button size="sm" type="button" class="btn btn-primary" @click="showModal('modal-proyecto')">Nuevo Proyecto</b-button>
          </div>
        </b-row> -->
        <!-- Control the column width, and how they should appear on different devices -->
        <div class="row">
          <div class="col-1 pt-3">
            <div :class="[showStyle1 ? 'btnStaticShow' : 'btnStaticHiden']">
              <b-list-group class="hands">
                <b-list-group-item
                  id="proyecto"
                  @drag="drag"
                  @dragend="dragend"
                  class="mb-2"
                  :class="[showStyle1 == false ? 'list-group-itemm' : '']"
                  draggable="true"
                  unselectable="on"
                >
                  <b-img
                    center
                    src="img/icons/btnSnf/proyecto.png"
                    fluid
                    title="Proyecto"
                  ></b-img>
                  <!--<i class="fa fa-chevron"></i>-->
                </b-list-group-item>
                <b-list-group-item
                  @drag="drag2"
                  @dragend="dragend2"
                  class="droppable-element mb-2"
                  draggable="true"
                  unselectable="on"
                  :class="[showStyle1 == false ? 'list-group-itemm' : '']">
                    <b-img
                      center
                      src="img/icons/btnSnf/promotor.png"
                      fluid
                      title="Promotor">
                    </b-img>
                  <!--<i class="fa fa-chevron"></i>-->
                </b-list-group-item>
                <b-list-group-item
                  @drag="drag3"
                  @dragend="dragend3"
                  class="droppable-element mb-2"
                  draggable="true"
                  unselectable="on"
                  :class="[showStyle1 == false ? 'list-group-itemm' : '']"
                  ><b-img
                    center
                    src="img/icons/btnSnf/comunidad.png"
                    fluid
                    title="Intervenidos/Impactos"
                  ></b-img>
                  <!--<i class="fa fa-chevron"></i>-->
                </b-list-group-item>
                <b-list-group-item
                  @drag="drag4"
                  @dragend="dragend4"
                  class="droppable-element mb-2"
                  draggable="true"
                  unselectable="on"
                  :class="[showStyle1 == false ? 'list-group-itemm' : '']"
                >
                  <b-img
                    center
                    src="img/icons/btnSnf/responsabilidad.png"
                    fluid
                    title="Responsabilidad"
                  ></b-img>
                  <!--<i class="fa fa-chevron"></i>-->
                </b-list-group-item>
                <b-list-group-item
                  @drag="drag5"
                  @dragend="dragend5"
                  class="droppable-element mb-2"
                  draggable="true"
                  unselectable="on"
                  :class="[showStyle1 == false ? 'list-group-itemm' : '']"
                >
                  <b-img
                    center
                    src="img/icons/btnSnf/recursos.png"
                    fluid
                    title="Recursos"
                  ></b-img>
                  <!--<i class="fa fa-chevron"></i>-->
                </b-list-group-item>
                <b-list-group-item
                  @drag="drag6"
                  @dragend="dragend6"
                  class="droppable-element mb-2"
                  draggable="true"
                  unselectable="on"
                  :class="[showStyle1 == false ? 'list-group-itemm' : '']"
                >
                  <b-img
                    center
                    src="img/icons/btnSnf/dialogo.png"
                    fluid
                    title="Dialogo"
                  ></b-img>
                  <!--<i class="fa fa-chevron"></i>-->
                </b-list-group-item>
                <b-list-group-item
                  @drag="drag7"
                  @dragend="dragend7"
                  class="droppable-element mb-2"
                  :class="[showStyle1 == false ? 'list-group-itemm' : '']"
                  draggable="true"
                  unselectable="on"
                >
                  <b-img
                    center
                    src="img/icons/btnSnf/beneficiario.png"
                    fluid
                    title="Comunidad"
                  ></b-img>
                  <!--<i class="fa fa-chevron"></i>-->
                </b-list-group-item>
                <b-list-group-item
                  @drag="drag8"
                  @dragend="dragend8"
                  class="droppable-element mb-2"
                  :class="[showStyle1 == false ? 'list-group-itemm' : '']"
                  draggable="true"
                  unselectable="on"
                >
                  <b-img
                    center
                    src="img/icons/btnSnf/beneficios.png"
                    fluid
                    title="Beneficios"
                  ></b-img>
                  <!--<i class="fa fa-chevron"></i>-->
                </b-list-group-item>
              </b-list-group>
            </div>
          </div>
  
          <div class="col-sm-1"></div>
          <div class="col-sm-9 pt-2" style="background-color: #f5f5f5; width: 100px; height: 100%">
            <!--Begin Column overflow: scroll;-->
  
            <div class="font-weight-light">
              <table class="table text-center" style="cursor: pointer; background-color: #fff">
                <tr class="cellbackgr">
                  <th colspan="2"><h3>Panel</h3></th>
                </tr>
                <tr class="border-primary">
                  <td colspan="2">
                    <h3 v-b-popover="popOver[0]">Proyecto</h3>
                    <!--Zone Drop-->
                    <div id="content" style="width: 100%; margin-top: 10px; height: 100%">
                      <grid-layout
                        ref="gridlayout"
                        :layout.sync="layout"
                        :col-num="12"
                        :row-height="30"
                        :is-draggable="draggable"
                        :is-resizable="resizable"
                        :responsive="responsive"
                        :vertical-compact="true"
                        :use-css-transforms="true"
                        :style="layout.length == 0 ? 'height: 100px' : ''"
                      >
                        <grid-item
                          v-for="item in layout"
                          :key="item.i"
                          :static="item.static"
                          :x="item.x"
                          :y="item.y"
                          :w="item.w"
                          :h="item.h"
                          :i="item.i"
                          class="list-group-item list-group-item-action list-group-item-warning"
                          :class="[showStyle1 ? 'style1' : 'style2']"
                        >
                          <div @dblclick="editModal('modal-proyecto', item)">
                            <span class="text textb">
                              {{ (item.data.Proyecto.nombre!==""?item.data.Proyecto.nombre:item.data.Nombre) }}<br/>
                              <br> <ul class="list-group"><li v-for="itemComp in item.data.Proyecto.componentes" :key="itemComp.id">{{ itemComp.nombre }}</li></ul>
                              <br>{{ item.data.Proyecto.monto }}
                            </span>
                          </div>
                          <div>
                            <span class="remove" @click="removeItem(item.i, 1)">x</span>
                          </div>
                        </grid-item>
                      </grid-layout>
                    </div>
                    <!--End Zone Drop-->
                  </td>
                </tr>
                <tr class="headt">
                  <td class="border-right">
                    <h3 v-b-popover="popOver[1]">Promotores/Beneficios</h3>
                    <!--ZoneDrop-->
                    <div id="content2" style="width: 100%; margin-top: 10px; height: 100%">
                      <grid-layout
                        ref="gridlayout2"
                        :layout.sync="layout2"
                        :col-num="12"
                        :row-height="30"
                        :is-draggable="draggable"
                        :is-resizable="resizable"
                        :responsive="responsive"
                        :vertical-compact="true"
                        :use-css-transforms="true"
                        :style="layout2.length == 0 ? 'height: 100px' : ''"
                      >
                        <grid-item
                          v-for="item in layout2"
                          :key="item.i"
                          :static="item.static"
                          :x="item.x"
                          :y="item.y"
                          :w="item.w"
                          :h="item.h"
                          :i="item.i"
                          class="list-group-item list-group-item-action list-group-item-warning"
                          :class="[showStyle1 ? 'style3' : 'style4']"
                        >
                          <div @dblclick="editModal('modal-promotor', item)">
                            <span v-if="item.data.Nombre ===''" class="text textb"> -- doble Click para agregar datos --</span>
                            <span v-if="item.data.Promotor.actorSocial!==''" class="text textb">Actor: {{ item.data.Promotor.actorSocial }} <br/> Descripción: <br/>{{ item.data.Promotor.descripcion!==null?item.data.Promotor.descripcion:"" | acorcad}}</span>
                          </div>
                          <div>
                            <span class="remove" @click="removeItem(item.i, 2)"
                              >x</span
                            >
                          </div>
                        </grid-item>
                      </grid-layout>
                    </div>
                    <!--ZoneDrop-->
                  </td>
                  <td>
                    <h3 v-b-popover="popOver[2]">
                      Intervenidos/Impactos <strong>(+/-)</strong>
                    </h3>
                    <!--ZoneDrop-->
                    <div id="content3" style="width: 100%; margin-top: 10px; height: 100%">
                      <grid-layout
                        ref="gridlayout3"
                        :layout.sync="layout3"
                        :col-num="12"
                        :row-height="30"
                        :is-draggable="draggable"
                        :is-resizable="resizable"
                        :responsive="responsive"
                        :vertical-compact="true"
                        :use-css-transforms="true"
                        :style="layout3.length == 0 ? 'height: 100px' : ''"
                      >
                        <grid-item
                          v-for="item in layout3"
                          :key="item.i"
                          :static="item.static"
                          :x="item.x"
                          :y="item.y"
                          :w="item.w"
                          :h="item.h"
                          :i="item.i"
                          class="list-group-item list-group-item-action list-group-item-warning"
                          :class="[showStyle1 ? 'style5' : 'style6']"
                        >
                          <div @dblclick="editModal('modal-beneficiario', item)">
                            <span v-if="item.data.Beneficiario.actor===''" class="text textb">-- Click para agregar datos --</span>
                            <span v-if="item.data.Beneficiario.actor!==''" class="text textb">{{ item.data.Beneficiario.actor }} <br/>{{item.data.Beneficiario.descripcion | acorcad}}</span>
                          </div>
                          <div>
                            <span class="remove" @click="removeItem(item.i, 3)"
                              >x</span
                            >
                          </div>
                        </grid-item>
                      </grid-layout>
                    </div>
                    <!--ZoneDrop-->
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <h3 v-b-popover="popOver[3]">Responsabilidades</h3>
                    <!--ZoneDrop-->
                    <div id="content4" style="width: 100%; margin-top: 10px; height: 100%">
                      <grid-layout
                        ref="gridlayout4"
                        :layout.sync="layout4"
                        :col-num="12"
                        :row-height="30"
                        :is-draggable="draggable"
                        :is-resizable="resizable"
                        :responsive="responsive"
                        :vertical-compact="true"
                        :use-css-transforms="true"
                        :style="layout4.length == 0 ? 'height: 100px' : ''"
                      >
                        <grid-item
                          v-for="item in layout4"
                          :key="item.i"
                          :static="item.static"
                          :x="item.x"
                          :y="item.y"
                          :w="item.w"
                          :h="item.h"
                          :i="item.i"
                          class="list-group-item list-group-item-action list-group-item-warning"
                          :class="[showStyle1 ? 'style7' : 'style8']"
                        >
                          <div @dblclick="editModal('modal-responsabilidades', item)">
                            <span v-if="selPromResponsabilidad == null" class="text textb">-- Click para agregar datos --</span>
                            <span v-if="selPromResponsabilidad != null" class="text textb">{{ selPromResponsabilidad }} <br/>
                               <br/>{{item.data.Responsabilidad.responsable | acorcad}} <br/>
                               <br/> {{ item.data.Responsabilidad.comentarios | acorcad }} </span>
                          </div>
                          <div>
                            <span class="remove" @click="removeItem(item.i, 4)"
                              >x</span
                            >
                          </div>
                        </grid-item>
                      </grid-layout>
                    </div>
                    <!--ZoneDrop-->
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <h3 v-b-popover="popOver[4]">Recursos Sociales</h3>
                    <!--ZoneDrop-->
                    <div id="content5" style="width: 100%; margin-top: 10px; height: 100%">
                      <grid-layout
                        ref="gridlayout5"
                        :layout.sync="layout5"
                        :col-num="12"
                        :row-height="30"
                        :is-draggable="draggable"
                        :is-resizable="resizable"
                        :responsive="responsive"
                        :vertical-compact="true"
                        :use-css-transforms="true"
                        :style="layout5.length == 0 ? 'height: 100px' : ''"
                      >
                        <grid-item
                          v-for="item in layout5"
                          :key="item.i"
                          :static="item.static"
                          :x="item.x"
                          :y="item.y"
                          :w="item.w"
                          :h="item.h"
                          :i="item.i"
                          class="list-group-item list-group-item-action list-group-item-warning"
                          :class="[showStyle1 ? 'style9' : 'style10']"
                        >
                          <div @dblclick="editModal('modal-recurso', item)">
                            <span v-if="selRecursoSocial === null" class="text textb">-- Click para agregar datos --</span>
                            <span v-if="item.data !== null" class="text textb"> {{ selRecursoSocial }} <br/>
                            <br/> {{item.data.Recurso.comentarios | acorcad}}</span>
                          </div>
                          <div>
                            <span class="remove" @click="removeItem(item.i, 5)"
                              >x</span
                            >
                          </div>
                        </grid-item>
                      </grid-layout>
                    </div>
                    <!--ZoneDrop-->
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <h3 v-b-popover="popOver[5]">Mecanismo Diálogo</h3>
                    <!--ZoneDrop-->
                    <div id="content6" style="width: 100%; margin-top: 10px; height: 100%">
                      <grid-layout
                        ref="gridlayout6"
                        :layout.sync="layout6"
                        :col-num="12"
                        :row-height="30"
                        :is-draggable="draggable"
                        :is-resizable="resizable"
                        :responsive="responsive"
                        :vertical-compact="true"
                        :use-css-transforms="true"
                        :style="layout6.length == 0 ? 'height: 100px' : ''"
                      >
                        <grid-item
                          v-for="item in layout6"
                          :key="item.i"
                          :static="item.static"
                          :x="item.x"
                          :y="item.y"
                          :w="item.w"
                          :h="item.h"
                          :i="item.i"
                          class="list-group-item list-group-item-action list-group-item-warning"
                          :class="[showStyle1 ? 'style11' : 'style12']"
                        >
                          <div @dblclick="editModal('modal-dialogo', item)">
                            <span v-if="item.data.Dialogo.comentario ==''" class="text textb">-- Click para agregar datos --</span>
                            <span v-if="item.data.Dialogo.comentario !=''" class="text textb">{{ item.data.Dialogo.comentario | acorcad}} <br/>
                               <ul class="list-group"><li v-for="itemComp in item.data.Dialogo.selected" :key="itemComp">{{ itemComp }}</li></ul>
                            </span>
                          </div>
                          <div>
                            <span class="remove" @click="removeItem(item.i, 6)"
                              >x</span
                            >
                          </div>
                        </grid-item>
                      </grid-layout>
                    </div>
                    <!--ZoneDrop-->
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <h3 v-b-popover="popOver[6]">Compromiso con la Comunidad</h3>
                    <!--ZoneDrop-->
                    <div id="content7" style="width: 100%; margin-top: 10px; height: 100%">
                      <grid-layout
                        ref="gridlayout7"
                        :layout.sync="layout7"
                        :col-num="12"
                        :row-height="30"
                        :is-draggable="draggable"
                        :is-resizable="resizable"
                        :responsive="responsive"
                        :vertical-compact="true"
                        :use-css-transforms="true"
                        :style="layout7.length == 0 ? 'height: 100px' : ''"
                      >
                        <grid-item
                          v-for="item in layout7"
                          :key="item.i"
                          :static="item.static"
                          :x="item.x"
                          :y="item.y"
                          :w="item.w"
                          :h="item.h"
                          :i="item.i"
                          class="list-group-item list-group-item-action list-group-item-warning"
                          :class="[showStyle1 ? 'style13' : 'style14']"
                        >
                          <div @dblclick="editModal('modal-compromiso', item)">
                            <span v-if="item.data.Compromiso.comentario ==''" class="text textb">-- Click para agregar datos --</span>
                            <span v-if="item.data.Compromiso.comentario !=''" class="text textb">{{ item.data.Compromiso.comentario | acorcad}} <br/>
                              <ul class="list-group"><li v-for="itemComp in item.data.Compromiso.selected" :key="itemComp">{{ itemComp }}</li></ul>
                            </span>                          
                          </div>
                          <div>
                            <span class="remove" @click="removeItem(item.i, 7)"
                              >x</span
                            >
                          </div>
                        </grid-item>
                      </grid-layout>
                    </div>
                    <!--ZoneDrop-->
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <h3 v-b-popover="popOver[7]">Beneficios</h3>
                    <!--ZoneDrop-->
                    <div id="content8" style="width: 100%; margin-top: 10px; height: 100%">
                      <grid-layout
                        ref="gridlayout8"
                        :layout.sync="layout8"
                        :col-num="12"
                        :row-height="30"
                        :is-draggable="draggable"
                        :is-resizable="resizable"
                        :responsive="responsive"
                        :vertical-compact="true"
                        :use-css-transforms="true"
                        :style="layout8.length == 0 ? 'height: 100px' : ''"
                      >
                        <grid-item
                          v-for="item in layout8"
                          :key="item.i"
                          :static="item.static"
                          :x="item.x"
                          :y="item.y"
                          :w="item.w"
                          :h="item.h"
                          :i="item.i"
                          class="list-group-item list-group-item-action list-group-item-warning"
                          :class="[showStyle1 ? 'style15' : 'style16']"
                        >
                          <div @dblclick="editModal('modal-rentabilidad', item)">
                            <span v-if="selRentabilidadAS == null" class="text textb">-- Click para agregar datos --</span>
                            <span v-if="selRentabilidadAS != null" class="text textb"><br/>
                              <br/> {{ item.data.Rentabilidad.beneficio | acorcad}} <br/>
                              <br/>{{ item.data.Rentabilidad.comentarios | acorcad}}</span>                          
                          </div>
                          <div>
                            <span class="remove" @click="removeItem(item.i, 8)"
                              >x</span
                            >
                          </div>
                        </grid-item>
                      </grid-layout>
                    </div>
                    <!--ZoneDrop-->
                  </td>
                </tr>
              </table>
            </div>
            <!--End colum-->
          </div>
          <div class="col-sm-1"></div>
        </div>
      </b-container>
  
      <!--Modal-->
      <b-modal
        id="modal-herr"
        ref="modal-herr"
        title="Herramienta SNF"
        @show="resetModal"
        @hidden="resetModal"
        @ok="handleOk"
      >
        <form ref="form" @submit.stop.prevent="handleSubmit">
          <b-form-group label="Label" label-for="name-input">
            <b-form-input
              id="name-input"
              v-model="name"
              :state="nameState"
              required
            ></b-form-input>
            <br />
            <p class="text-center">
              <b>Lorem Ipsum</b><br />
              <small
                >"Neque porro quisquam est qui dolorem ipsum quia dolor sit amet,
                consectetur, adipisci velit..." "There is no one who loves pain
                itself, who seeks after it and wants to have it, simply because it
                is pain..."</small
              >
            </p>
          </b-form-group>
        </form>
      </b-modal>
      <!--End Modal-->
  
      <!--Modals Add componente-->
      <b-modal id="modal-multi-3" size="sm" title="Third Modal" ok-only>
        <p class="my-1">Agregar Componente</p>
        <b-form-group
          id="nombre-componente"
          label-cols-sm="4"
          label-cols-lg="3"
          content-cols-sm
          content-cols-lg="7"
          description=""
          label="Nombre del Componente"
          label-for="nombreComponente"
          label-size="sm"
        >
          <b-form-input
            size="sm"
            id="nombreComponente"
            v-model="proyecto.componente"
          ></b-form-input>
        </b-form-group>
        <b-button><i class="fa fa-save"></i>Guardar</b-button>
      </b-modal>

      <!--Modal Proyecto-->
      <b-modal
        id="m-proyecto"
        ref="modal-proyecto"
        title="Proyecto"
        @show="resetModal"
        @hidden="resetModal"
      >
        <form ref="proyecto" @submit.stop.prevent="handleSubmitProyecto">
          <b-form-group
            id="nombre-proyecto"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Nombre:"
            label-for="nombreProyecto"
            label-size="sm"
          >
            <b-form-input
              size="sm"
              id="nombreProyecto"
              v-model="proyecto.nombre"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="objetivo-proyecto"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Objetivo"
            label-for="objetivoProyecto"
            label-size="sm"
          >
            <b-form-input
              size="sm"
              id="objetivoProyecto"
              v-model="proyecto.objetivo"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="componentes-proyecto"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Componentes"
            label-for="componentesProyecto"
            label-size="sm"
          >
            <b-form-input
              size="sm"
              id="componentesProyecto"
              v-model="proyecto.componente"
            ></b-form-input>
          </b-form-group>
          <!--@click="addPais()"-->
          <b-button
            class="float-right"
            variant="success"
            size="sm"
            @click="addComponente()"
            ><i class="fa fa-plus"></i> Agregar
          </b-button>
          <br /><br />
          <!--Tabla-->
          <table class="table table-striped table-sm">
            <thead>
              <tr>
                <!--<th scope="col">#</th>-->
                <th scope="col">ID</th>
                <th scope="col">Componente</th>
                <th scope="col">---</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="itemc in proyecto.componentes" :key="itemc.id">
                <td>{{ itemc.id }}</td>
                <td>{{ itemc.nombre }}</td>
                <td>
                  <b-button
                    size="sm"
                    variant="danger"
                    @click="deleteComponente(itemc.id)"
                    ><i class="fa fa-minus-circle"></i
                  ></b-button>
                </td>
              </tr>
            </tbody>
          </table>
          <!--Fin tabla-->
          <br />
          <b-form-group
            id="monto-proyecto"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Monto"
            label-for="montoProyecto"
            label-size="sm"
          >
            <b-form-input
              size="sm"
              type="number"
              step=".01"
              id="montoProyecto"
              v-model="proyecto.monto"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="desc-proyecto"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Descripción"
            label-for="descripcion-proyecto"
            label-size="sm"
          >
            <b-form-input
              size="sm"
              id="descripcion-proyecto"
              v-model="proyecto.descripcion"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="coord-proyecto"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Coordenadas"
            label-for="coordenadas-proyecto"
            label-size="sm"
          >
            <b-form-input
              size="sm"
              id="coordenadas-proyecto"
              v-model="proyecto.coordenadas"
            ></b-form-input>
          </b-form-group>
        </form>
        <template #modal-footer>
          <div class="w-100">
            <b-row>
              <b-col>
                <b-button
                  variant="primary"
                  size="sm"
                  class="float-left"
                  @click="handleOk(1)"
                >
                  <i class="fa fa-save"></i> Guardar
                </b-button>
              </b-col>
              <b-col class="text-rigth">
                <b-button
                  variant="danger"
                  size="sm"
                  class="float-right"
                  @click="hideModal('modal-proyecto')"
                >
                  <i class="fa fa-times"></i> Cerrar
                </b-button>
              </b-col>
            </b-row>
          </div>
        </template>
      </b-modal>
  
      <!--Modal Promotor-->
      <b-modal
        id="promotor"
        ref="modal-promotor"
        title="Promotor"
        @show="resetModal"
        @hidden="resetModal"
      >
        <form ref="promotor" @submit.stop.prevent="handleSubmit">
          <b-container class="p-2">
            <b-form-group
              id="actor-social"
              label-cols-sm="4"
              label-cols-lg="3"
              content-cols-sm
              content-cols-lg="7"
              description=""
              label="Actor Social"
              label-for="actsocial"
              label-size="sm"
            >
              <b-form-input
                size="sm"
                id="actsocial"
                v-model="promotor.actorSocial"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="tipo-promotor"
              label-cols-sm="4"
              label-cols-lg="3"
              content-cols-sm
              content-cols-lg="7"
              description=""
              label="Tipo:"
              label-for="tipo"
              label-size="sm"
            >
              <b-form-select
                id="tipo"
                v-model="selTipoPromotor"
                :options="promotor.tipo"
                size="sm"
                class="mt-3"
              ></b-form-select>
            </b-form-group>
            <b-form-group
              id="desc1-promotor"
              label-cols-sm="4"
              label-cols-lg="3"
              content-cols-sm
              content-cols-lg="7"
              description=""
              label="Descripción"
              label-for="desc-promotor"
              label-size="sm"
            >
              <b-form-textarea
                id="desc-promotor"
                v-model="promotor.descripcion"
                placeholder="..."
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>
            <b-form-group
              id="comen-promotor"
              label-cols-sm="4"
              label-cols-lg="3"
              content-cols-sm
              content-cols-lg="7"
              description=""
              label="Comentario"
              label-for="comen-promotor"
              label-size="sm"
            >
              <b-form-textarea
                id="comen-promotor"
                v-model="promotor.comentarios"
                placeholder="..."
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>
          </b-container>
        </form>
        <template #modal-footer>
          <div class="w-100">
            <b-row>
              <b-col>
                <b-button
                  variant="primary"
                  size="sm"
                  class="float-left"
                  @click="handleOk(2)"
                >
                  <i class="fa fa-save"></i> Guardar
                </b-button>
              </b-col>
              <b-col class="text-rigth">
                <b-button
                  variant="danger"
                  size="sm"
                  class="float-right"
                  @click="hideModal('modal-promotor')"
                >
                  <i class="fa fa-times"></i> Cerrar
                </b-button>
              </b-col>
            </b-row>
          </div>
        </template>
      </b-modal>
  
      <!--Modal Intervenidos-->
      <b-modal
        id="modal-benef"
        ref="modal-beneficiario"
        title="Intervenidos"
        @show="resetModal"
        @hidden="resetModal"
      >
        <form ref="beneficiario" @submit.stop.prevent="handleSubmit">
          <b-container class="p-2">
            <b-form-group
              id="actor-social"
              label-cols-sm="4"
              label-cols-lg="3"
              content-cols-sm
              content-cols-lg="7"
              description=""
              label="Actor Social"
              label-for="actor-beneficiario"
              label-size="sm"
            >
              <b-form-input
                size="sm"
                id="actor-beneficiario"
                v-model="beneficiario.actor"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="desc1-beneficiario"
              label-cols-sm="4"
              label-cols-lg="3"
              content-cols-sm
              content-cols-lg="7"
              description=""
              label="Descripcion"
              label-for="desc-beneficiario"
              label-size="sm"
            >
              <b-form-textarea
                id="desc-beneficiario"
                v-model="beneficiario.descripcion"
                placeholder="..."
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>
            <b-form-group
              id="comen-beneficiario"
              label-cols-sm="4"
              label-cols-lg="3"
              content-cols-sm
              content-cols-lg="7"
              description=""
              label="Comentarios"
              label-for="comen-beneficiario"
              label-size="sm"
            >
              <b-form-textarea
                id="comen-beneficiario"
                v-model="beneficiario.comentarios"
                placeholder="..."
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>
            <br /><br />
          </b-container>
        </form>
        <template #modal-footer>
          <div class="w-100">
            <b-row>
              <b-col>
                <b-button
                  variant="primary"
                  size="sm"
                  class="float-left"
                  @click="handleOk(3)"
                >
                  <i class="fa fa-save"></i> Guardar
                </b-button>
              </b-col>
              <b-col class="text-rigth">
                <b-button
                  variant="danger"
                  size="sm"
                  class="float-right"
                  @click="hideModal('modal-beneficiario')"
                >
                  <i class="fa fa-times"></i> Cerrar
                </b-button>
              </b-col>
            </b-row>
          </div>
        </template>
      </b-modal>
  
      <!--Modal Responsabilidades-->
      <b-modal
        id="modal-respon"
        ref="modal-responsabilidades"
        title="Responsabilidades"
        @show="resetModal"
        @hidden="resetModal"
      >
        <form ref="responsabilidades" @submit.stop.prevent="handleSubmit">
          <b-container class="p-2">
            <b-form-group
              id="actorSoc-responsabilidades"
              label-cols-sm="4"
              label-cols-lg="3"
              content-cols-sm
              content-cols-lg="7"
              description=""
              label="Actor Social:"
              label-for="actorSoc-responsabilidades"
              label-size="sm"
            >
              <b-form-select
                id="actorSoc-responsabilidades"
                v-model="selPromResponsabilidad"
                :options="responsabilidades.actores"
                size="sm"
                class="mt-3"
              ></b-form-select>
            </b-form-group>
            <!--<b-form-group
              id="benef-responsabilidades"
              label-cols-sm="4"
              label-cols-lg="3"
              content-cols-sm
              content-cols-lg="7"
              description=""
              label="Beneficiarios:"
              label-for="beneficiario-responsabilidades"
              label-size="sm"
            >
              <b-form-select
                id="beneficiario-responsabilidades"
                v-model="selBenefResponsabilidad"
                :options="responsabilidades.beneficiarios"
                size="sm"
                class="mt-3"
              ></b-form-select>
            </b-form-group>-->
            <b-form-group
              id="activ-responsabilidad"
              label-cols-sm="4"
              label-cols-lg="3"
              content-cols-sm
              content-cols-lg="7"
              description=""
              label="Responsabilidad:"
              label-for="responsable-responsabilidades"
              label-size="sm"
            >
              <b-form-input
                size="sm"
                id="responsable-responsabilidades"
                v-model="responsabilidades.responsable"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="coment-responsabilidades"
              label-cols-sm="4"
              label-cols-lg="3"
              content-cols-sm
              content-cols-lg="7"
              description=""
              label="Comantarios"
              label-for="comentarios-responsabilidades"
              label-size="sm"
            >
              <b-form-textarea
                id="comentarios-responsabilidades"
                v-model="responsabilidades.comentarios"
                placeholder="..."
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>
          </b-container>
        </form>
        <template #modal-footer>
          <div class="w-100">
            <b-row>
              <b-col>
                <b-button
                  variant="primary"
                  size="sm"
                  class="float-left"
                  @click="handleOk(4)"
                >
                  <i class="fa fa-save"></i> Guardar
                </b-button>
              </b-col>
              <b-col class="text-rigth">
                <b-button
                  variant="danger"
                  size="sm"
                  class="float-right"
                  @click="hideModal('modal-responsabilidades')"
                >
                  <i class="fa fa-times"></i> Cerrar
                </b-button>
              </b-col>
            </b-row>
          </div>
        </template>
      </b-modal>
  
      <!--Modal Recursos Sociales-->
      <b-modal
        id="modal-prevent-closing"
        ref="modal-recurso"
        title="Recursos Sociales"
        @show="resetModal"
        @hidden="resetModal"
      >
        <form ref="recurso" @submit.stop.prevent="handleSubmit">
          <b-form-group
            id="actorSoc-recursoSocial"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Actor Social:"
            label-for="actorSoc-recursoSocial"
            label-size="sm"
          >
            <b-form-select
              id="actorSoc-recursoSocial"
              v-model="selRecursoSocial"
              :options="recurso.actorSocial"
              size="sm"
              class="mt-3"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            id="activ-recursoSocial"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Recurso:"
            label-for="recurso-recursoSocial"
            label-size="sm"
          >
            <b-form-input
              size="sm"
              id="recurso-recursoSocial"
              v-model="recurso.recursoSocial"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="coment-recursoSocial"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Comantarios"
            label-for="comentarios-recursoSocial"
            label-size="sm"
          >
            <b-form-textarea
              id="comentarios-recursoSocial"
              v-model="recurso.comentarios"
              placeholder="..."
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </b-form-group>
        </form>
        <template #modal-footer>
          <div class="w-100">
            <b-row>
              <b-col>
                <b-button
                  variant="primary"
                  size="sm"
                  class="float-left"
                  @click="handleOk(5)"
                >
                  <i class="fa fa-save"></i> Guardar
                </b-button>
              </b-col>
              <b-col class="text-rigth">
                <b-button
                  variant="danger"
                  size="sm"
                  class="float-right"
                  @click="hideModal('modal-recurso')"
                >
                  <i class="fa fa-times"></i> Cerrar
                </b-button>
              </b-col>
            </b-row>
          </div>
        </template>
      </b-modal>
  
      <!--Modal Mecanismo de dialogo-->
      <b-modal
        id="modal-dialog"
        ref="modal-dialogo"
        title="Mecanismo de Dialogo"
        @show="resetModal"
        @hidden="resetModal"
      >
        <form ref="dialogo" @submit.stop.prevent="handleSubmit">
          <b-container class="p-2">
            <b-form-group v-slot="{ ariaDescribedby }">
              <b-form-checkbox-group
                v-model="dialogo.selected"
                :options="dialogo.options"
                :aria-describedby="ariaDescribedby"
                name="flavour-2a"
                stacked
              ></b-form-checkbox-group>
            </b-form-group>
            <br />
            <b-form-group
              id="comen-dialogo"
              label-cols-sm="4"
              label-cols-lg="3"
              content-cols-sm
              content-cols-lg="7"
              description=""
              label="Comentario"
              label-for="comentario-dialogo"
              label-size="sm"
            >
              <b-form-textarea
                id="comentario-dialogo"
                v-model="dialogo.comentario"
                placeholder="..."
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>
          </b-container>
        </form>
        <template #modal-footer>
          <div class="w-100">
            <b-row>
              <b-col>
                <b-button
                  variant="primary"
                  size="sm"
                  class="float-left"
                  @click="handleOk(6)"
                >
                  <i class="fa fa-save"></i> Guardar
                </b-button>
              </b-col>
              <b-col class="text-rigth">
                <b-button
                  variant="danger"
                  size="sm"
                  class="float-right"
                  @click="hideModal('modal-dialogo')"
                >
                  <i class="fa fa-times"></i> Cerrar
                </b-button>
              </b-col>
            </b-row>
          </div>
        </template>
      </b-modal>
  
      <!--Modal Compromiso con la comunidad-->
      <b-modal
        id="modal-compro"
        ref="modal-compromiso"
        title="Compromiso con la comunidad"
        @show="resetModal"
        @hidden="resetModal"
      >
        <form ref="compromiso" @submit.stop.prevent="handleSubmit">
          <b-container class="p-2">
            <b-form-group v-slot="{ ariaDescribedby }">
              <b-form-checkbox-group
                v-model="compromiso.selected"
                :options="compromiso.options"
                :aria-describedby="ariaDescribedby"
                name="flavour-2a"
                stacked
              ></b-form-checkbox-group>
            </b-form-group>
            <br />
            <b-form-group
              id="comen-compromiso"
              label-cols-sm="4"
              label-cols-lg="3"
              content-cols-sm
              content-cols-lg="7"
              description=""
              label="Comentario"
              label-for="comentario-compromiso"
              label-size="sm"
            >
              <b-form-textarea
                id="comentario-compromiso"
                v-model="compromiso.comentario"
                placeholder="..."
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>
          </b-container>
        </form>
        <template #modal-footer>
          <div class="w-100">
            <b-row>
              <b-col>
                <b-button
                  variant="primary"
                  size="sm"
                  class="float-left"
                  @click="handleOk(7)"
                >
                  <i class="fa fa-save"></i> Guardar
                </b-button>
              </b-col>
              <b-col class="text-rigth">
                <b-button
                  variant="danger"
                  size="sm"
                  class="float-right"
                  @click="hideModal('modal-compromiso')"
                >
                  <i class="fa fa-times"></i> Cerrar
                </b-button>
              </b-col>
            </b-row>
          </div>
        </template>
      </b-modal>
  
      <!--Modal Rentabilidad Social-->
      <b-modal
        id="modal-social"
        ref="modal-rentabilidad"
        title="Rentabilidad Social"
        @show="resetModal"
        @hidden="resetModal"
      >
        <form ref="rentabilidad" @submit.stop.prevent="handleSubmit">
          <b-container class="p-2">
            <b-form-group
              id="actorSoc-rentabilidad"
              label-cols-sm="4"
              label-cols-lg="3"
              content-cols-sm
              content-cols-lg="7"
              description=""
              label="Actor Social:"
              label-for="actorSoc-rentabilidad"
              label-size="sm"
            >
              <b-form-select
                id="actorSoc-rentabilidad"
                v-model="selRentabilidadAS"
                :options="rentabilidad.actorSocial"
                size="sm"
                class="mt-3"
              ></b-form-select>
            </b-form-group>
            <b-form-group
              id="activ-rentabilidad"
              label-cols-sm="4"
              label-cols-lg="3"
              content-cols-sm
              content-cols-lg="7"
              description=""
              label="Beneficio:"
              label-for="beneficio-rentabilidad"
              label-size="sm"
            >
              <b-form-input
                size="sm"
                id="beneficio-rentabilidad"
                v-model="rentabilidad.beneficio"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="coment-rentabilidad"
              label-cols-sm="4"
              label-cols-lg="3"
              content-cols-sm
              content-cols-lg="7"
              description=""
              label="Comantarios"
              label-for="comentarios-rentabilidad"
              label-size="sm"
            >
              <b-form-textarea
                id="comentarios-rentabilidad"
                v-model="rentabilidad.comentarios"
                placeholder="..."
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>
          </b-container>
        </form>
        <template #modal-footer>
          <div class="w-100">
            <b-row>
              <b-col>
                <b-button
                  variant="primary"
                  size="sm"
                  class="float-left"
                  @click="handleOk(8)"
                >
                  <i class="fa fa-times"></i> Guardar
                </b-button>
              </b-col>
              <b-col class="text-rigth">
                <b-button
                  variant="danger"
                  size="sm"
                  class="float-right"
                  @click="hideModal('modal-rentabilidad')"
                >
                  <i class="fa fa-times"></i> Cerrar
                </b-button>
              </b-col>
            </b-row>
          </div>
        </template>
      </b-modal>

    </div>
  </template>
  
  <script>
  //import VueGridLayout from 'vue-grid-layout';
  //import DialogDrag from 'vue-dialog-drag'
  import { GridLayout, GridItem } from "vue-grid-layout";
  //import VueDragResize from 'vue-drag-resize';
  //import { Container, Draggable } from "vue-dndrop";
  //import { applyDrag, generateItems, scene } from "../../../util/helpers"
  //import { applyDrag, scene } from "../../../util/helpers";
  //import draggable from "vuedraggable";
  //import { Dropdown, DropdownItem, DropdownMenu, Form, Table, TableColumn } from 'element-ui';
  
  let mouseXY = { x: null, y: null };
  let DragPos = { x: null, y: null, w: 1, h: 1, i: null };
  
  export default {
    components: {
      GridLayout,
      GridItem,
      //DialogDrag, //no quitar
      //VueDragResize,
      //Container, Draggable,
      //draggable,
      /*[Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn*/
    },
    data() {
      return {
        visibleFormCrud: false,
        showStyle1: true,
        estilo1:
          "width: 15px; height: 15px; margin-top: -20px;margin-left: 50px;",
        estilo2:
          "width: 15px; height: 15px; margin-top: -20px;margin-left: 40px;",
        estilo3:
          "width: 15px; height: 15px; margin-top: -20px;margin-left: 50px;",
        estilo4:
          "width: 15px; height: 15px; margin-top: -20px;margin-left: 50px;",
        estilo5:
          "width: 15px; height: 15px; margin-top: -20px;margin-left: 50px;",
        estilo6:
          "width: 15px; height: 15px; margin-top: -20px;margin-left: 50px;",
  
        contentActual: "content",
        layout: [
          /*{ id: 1, x: 0, y: 0, w: 2, h: 2, i: "0", data:{Nombre: "proyecto "+ DragPos.i} },
          { id: 2, x: 2, y: 0, w: 2, h: 2, i: "1", data:{Nombre: "proyecto "+ DragPos.i} },
          { id: 3, x: 2, y: 0, w: 2, h: 2, i: "2", data:{Nombre: "proyecto "+ DragPos.i} },
          { id: 4, x: 2, y: 0, w: 2, h: 2, i: "3", data:{Nombre: "proyecto "+ DragPos.i} },*/
        ],
        layout2: [
          /*{ id: 1, x: 0, y: 0, w: 2, h: 2, i: "0" },
          { id: 2, x: 2, y: 0, w: 2, h: 2, i: "1" },
          { id: 3, x: 2, y: 0, w: 2, h: 2, i: "2" },
          { id: 4, x: 2, y: 0, w: 2, h: 2, i: "3" },*/
        ],
        layout3: [
          /*{ id: 1, x: 0, y: 0, w: 2, h: 2, i: "0" },
          { id: 2, x: 2, y: 0, w: 2, h: 2, i: "1" },
          { id: 3, x: 2, y: 0, w: 2, h: 2, i: "2" },
          { id: 4, x: 2, y: 0, w: 2, h: 3, i: "3" },*/
        ],
        layout4: [
          /*{ id: 1, x: 0, y: 0, w: 2, h: 2, i: "0" },
          { id: 2, x: 2, y: 0, w: 2, h: 2, i: "1" },
          { id: 3, x: 2, y: 0, w: 2, h: 2, i: "2" },
          { id: 4, x: 2, y: 0, w: 2, h: 3, i: "3" },*/
        ],
        layout5: [
          /*{ id: 1, x: 0, y: 0, w: 2, h: 1, i: "0" },
          { id: 2, x: 1, y: 0, w: 2, h: 1, i: "1" },
          { id: 3, x: 1, y: 0, w: 2, h: 1, i: "2" },
          { id: 4, x: 1, y: 0, w: 2, h: 1, i: "3" },*/
        ],
        layout6: [
          /*{ id: 1, x: 1, y: 0, w: 2, h: 1, i: "0" },
          { id: 2, x: 1, y: 0, w: 2, h: 1, i: "1" },
          { id: 3, x: 1, y: 0, w: 2, h: 1, i: "2" },
          { id: 4, x: 1, y: 0, w: 2, h: 1, i: "3" },*/
        ],
        layout7: [
          /*{ id: 1, x: 0, y: 0, w: 2, h: 2, i: "0" },
          { id: 2, x: 2, y: 0, w: 2, h: 2, i: "1" },
          { id: 2, x: 4, y: 0, w: 2, h: 2, i: "2" },
          { id: 2, x: 6, y: 0, w: 2, h: 2, i: "3" },*/
        ],
        layout8: [
          /*{ id: 1, x: 0, y: 0, w: 2, h: 2, i: "0" },
          { id: 2, x: 2, y: 0, w: 2, h: 2, i: "1" },
          { id: 3, x: 2, y: 0, w: 2, h: 2, i: "2" },
          { id: 4, x: 2, y: 0, w: 2, h: 2, i: "3" },*/
        ],
        popOver: [
          "Proyecto: Es el proyecto de la empresa que impactara a los diversos grupos de interes.",
          "Promotores: Se refiere a los promotores del proyecto",
          "Recursos: Se refiere a los recursos o activos(dinero, propiedades, horas hombre, tiempo, etc)",
          "Responsabilidades. Se refiere a las responsbilidades que asumen cada promotor y/o beneficiario para diseñar e implementar el proyecto",
          "Recursos Recursos. Se refiere a los recursos o activos (dinero, propiedades, horas hombre, tiempo, etc.) que cada promotor y/o beneficiario ponen para realizar el proyecto",
          "Mecanismo de diálogo. Se refiere al mecanimos de diálogo para discutir y llegar a acuerdos respecto al diseño y la implementación del proyecto",
          "Compromiso con la comunidad. Se refiere al empoderamiento de los beneficiarios en el diseño y la gestión del proyecto.",
          "Beneficios. Se refiere a los beneficios que genera el proyecto tanto a los promotores como a los beneficiarios",
        ],
        listWidth: 0,
        listHeight: 0,
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        draggable: true,
        resizable: true,
        responsive: false,
        index: 0,
  
        list1: [],
        list2: [],
        list3: [],
        list4: [],
        list5: [],
        list6: [],
        list7: [],
        list8: [],
        //Area Modals--------------
        //Proyecto
        proyecto: new Form({
          nombre: "",
          objetivo: "",
          componente: "",
          componentes: [],
          monto: 0.0,
          descripcion: "",
          coordenadas: ""
        }),
        //promotor
        selTipoPromotor: null,
        selImpacProm: null,
        promotor: new Form({
          tipo: [
            { value: null, text: "Seleccione" },
            { value: "a", text: "PRINCIPAL" },
            { value: "b", text: "SECUNDARIO" },
          ],
          actorSocial: "",
          descripcion: "",
          comentarios: "",
          impactos: [
            { text: "Opcion 1", value: "op1" },
            { text: "Opcion 2", value: "op2" },
            { text: "Opcion 3", value: "op3" },
            { text: "Opcion 4", value: "op4" },
          ],
        }),
        //beneficiario
        selTipoImpacBenef: null,
        beneficiario: new Form({
          actor: "",
          comunidad: "",
          descripcion: "",
          comentarios: "",
          impactos: [
            { value: null, text: "Seleccione" },
            { value: "a", text: "Tipo A" },
            { value: "b", text: "Tipo B" },
          ],
        }),
        //responsabilidad
        selPromResponsabilidad: null,
        selBenefResponsabilidad: null,
        responsabilidades: new Form({
           actores: [
            { value: null, text: "Seleccione" },
            { value: "Tipo a", text: "Tipo A" },
            { value: "Tipo B", text: "Tipo B" },
          ],
          responsable: "",
          comentarios: "",
        }),
        //recurso Social
        selRecursoSocial: null,
        recurso: new Form({
          recursoSocial: "",
          nombreActor:"",
          comentarios: "",
          actorSocial: [
            { value: null, text: "Seleccione" },
            { value: "Actor A", text: "Actor A" },
            { value: "Actor B", text: "Actor B" },
          ]
        }),
        //dialogo
        dialogo: new Form({
          selected: [],
          comentario: "",
          options: [
            { text: "Sin dialogo", value: "Sin dialogo" },
            {
              text: "Logistica (Mecanismo de reclamos EIA, etc.)",
              value: "Logistica (Mecanismo de reclamos EIA, etc.)",
            },
            { text: "Mesa de Dialogo", value: "Mesa de Dialogo" },
            { text: "Mesa de desarrollo", value: "Mesa de desarrollo" },
            {
              text: "Mesa Ejecutiva Territorial",
              value: "Mesa Ejecutiva Territorial",
            },
          ],
        }),
        //compromiso
        compromiso: new Form({
          selected: [],
          comentario: "",
          options: [
            {
              text: "Sin gestión hacia la comunidad",
              value: "Sin gestión hacia la comunidad",
            },
            {
              text: "La empresa gestiona todo",
              value: "La empresa gestiona todo",
            },
            {
              text: "Co-gestión (Empresa-Comunidad)",
              value: "Co-gestión (Empresa-Comunidad)",
            },
            { text: "Gestión de la comunidad", value: "Gestión de la comunidad" },
          ],
        }),
        //Rentabilidad   
        selRentabilidadAS: null,     
        rentabilidad: new Form({         
          beneficio: "",
          comentarios: "",
          actorSocial: [
            { value: null, text: "Seleccione" }
          ],
        }),
        //------------------
        cardActual: 0,
        name: "",
        nameState: null,
        submittedNames: [],
        editmode: false,
        filtroActivo: false,
        perPage: 10,
        currentPage: 1,
        totalItemsRow: 10,
  
        filtro: new Form({
          nroFactura: "",
          codigoCaja: "",
          nroDocumento: "",
          idTurno: "",
          tiendaId: "-1",
          formaPagoId: "-1",
          Caja: 0,
          fechaI: this.getDate(),
          fechaF: this.getDate(),
          monto: 0,
          idCaja: "0",
        }),
      };
    },
    methods: {
      removeDialog (dialog) {
        let id = dialog.id
        let index = this.findDialog(id)
        this.dialogs.splice(index, 1)
        if (this.selected && this.selected.id === id) this.selected = null
      },    
      addComponente() {
        if (this.proyecto.componente != "") {
          this.proyecto.componentes.push({
            id: this.proyecto.componentes.length + 1,
            nombre: this.proyecto.componente,
          });
          this.proyecto.componente = '';
        } else {
          this.$swal("", "Debe agregar un nombre de componente", "error");
        }
      },
      deleteComponente(val) {
        const index = this.proyecto.componentes
          .map((item) => item.id)
          .indexOf(val);
        this.proyecto.componentes.splice(index, 1);
      },
      //--  Comp Comunidad
      //------------------------------
      addCard: function (key) {
        this.editmode = false;
        this.cardActual = key;
        this.name = "TEST" + key.toString();
  
        switch (key) {
          case 1:
            this.showModal("modal-proyecto");
            break;
          case 2:
            this.showModal("modal-promotor");
            break;
          case 3:
            this.showModal("modal-beneficiario");
            break;
          case 4:
            this.showModal("modal-responsabilidades");
            break;
          case 5:
            this.showModal("modal-recurso");
            break;
          case 6:
            this.showModal("modal-dialogo");
            break;
          case 7:
            this.showModal("modal-compromiso");
            break;
          case 8:
            this.showModal("modal-rentabilidad");
            break;
          default:
            this.showModal("modal-herr");
            break;
        }
      },
      CalcularRentabilidad() {
        if (
          this.rentabilidad.valorantesProyecto > 0 &&
          this.rentabilidad.valordespuesProyecto > 0
        ) {
          this.rentabilidad.diferencia =
            this.rentabilidad.valorantesProyecto -
            this.rentabilidad.valordespuesProyecto;
        } else {
        }
      },
      async updateProyecto(formProyecto){
        if(this.$route.query.hasOwnProperty('id')){
          const proyectoId = this.$route.query.id;

          formProyecto.put(this.$gate.getApiUrl()+'proyectos/'+proyectoId)
            .then(() => {
              // success
                this.hideModal("modal-proyecto");
                this.$swal(
                  'Actualizado!',
                  'Actualizado Correctamente!.',
                  'success'
                  )
                  // this.$Progress.finish();
                  //Fire.$emit('AfterCreate');
                  location.reload();
            })
            .catch((e) => {
              console.log(e)
              //this.$Progress.fail();
            });
        }
      },
      async saveComponente(form, url, modal){
        if(this.$route.query.hasOwnProperty('id')){
          const proyectoId = this.$route.query.id;
          form.proyectoId = proyectoId;
          if(url === 'responsabilidades'){
            form.actorSocial = this.selPromResponsabilidad;
          }

          if(url === 'recursos'){
            form.nombreActor = this.selRecursoSocial;
          } 
          
          if(url === 'rentabilidad'){
            form.actorSocial = this.selRentabilidadAS;
          } 
          //console.log(formProyecto)
          await form.post(this.$gate.getApiUrl() + 'proyectos/' + url)
            .then(() => {
              // success
                this.hideModal(modal);
                this.$swal(
                  'Actualizado!',
                  'Actualizado Correctamente!.',
                  'success'
                  )
                  // this.$Progress.finish();
                  //   Fire.$emit('AfterCreate');
            })
            .catch((e) => {
              console.log(e)
              if (e.response.status == 401) {
                    this.$gate.removeLogin();
                    this.$router.push("/Login");             
                    }
            });
        }
      },      
      handleOk(key, formActual, bvModalEvent) {
        //if (!this.editmode) {
        switch (key) {
          case 1:
            // this.list1.push({
            //   titulo: this.proyecto.nombre,
            //   data: this.proyecto,
            //   id: this.list1.length + 1,
            // });
            this.updateProyecto(this.proyecto);
            break;
  
          case 2:
            this.list2.push({
              name: "PROMOTOR -" + this.name,
              id: this.list2.length + 1,
            });
            this.responsabilidades.actores.push({
              value: this.promotor.actorSocial,
              text: this.promotor.actorSocial + " - (Promotor)",
            });
            this.recurso.actorSocial.push({
              value: this.promotor.actorSocial,
              text: this.promotor.actorSocial + " - (Promotor)",
            });
            console.log("Rentabilidad", this.rentabilidad)
            // this.rentabilidad.actorSocial.push({
            //   value: this.promotor.actorSocial,
            //   text: this.promotor.actorSocial + " - (Promotor)",
            // });

            this.saveComponente(this.promotor, 'promotor', 'modal-promotor');
            //this.hideModal("");
            break;
          case 3:
            this.list3.push({
              name: "BENEFICIARIO -" + this.name,
              id: this.list3.length + 1,
            });
            this.recurso.actorSocial.push({
              value: this.beneficiario.actor,
              text: this.beneficiario.actor + " - (Intervenidos)",
            });
            this.responsabilidades.actores.push({
              value: this.beneficiario.actor,
              text: this.beneficiario.actor + " - (Intervenidos)",
            }); 
            this.rentabilidad.actorSocial.push({
              value: this.beneficiario.actor,
              text: this.beneficiario.actor + " - (Intervenidos)",
            });
            this.saveComponente(this.beneficiario, 'beneficiario', 'modal-beneficiario');                      
            //this.hideModal("modal-beneficiario");
            break;
          case 4:
            this.list4.push({
              name: "RESPONSABILIDAD -" + this.name,
              id: this.list4.length + 1,
            });
            this.saveComponente(this.responsabilidades, 'responsabilidades', 'modal-responsabilidades');
            //this.hideModal("modal-responsabilidades");
            break;
          case 5:
            this.list5.push({
              name: "RECURSOS -" + this.name,
              id: this.list5.length + 1,
            });
            this.saveComponente(this.recurso, 'recursos', 'modal-recurso');
            //this.hideModal("modal-recurso");
            break;
          case 6:
            this.list6.push({
              name: "DIALOGO -" + this.name,
              id: this.list6.length + 1,
            });
            this.saveComponente(this.dialogo, 'dialogo', 'modal-dialogo');
            //this.hideModal("modal-dialogo");
            break;
          case 7:
            this.list7.push({
              name: "COMUNIDAD -" + this.name,
              id: this.list7.length + 1,
            });
            this.saveComponente(this.compromiso, 'compromiso', 'modal-compromiso');
            //this.hideModal("modal-compromiso");
            break;
          case 8:
            this.list8.push({
              name:
                "RESPONSABILIDAD SOCIAL -" + this.name + this.list8.length + 1,
              id: this.list8.length + 1,
            });
            this.saveComponente(this.rentabilidad, 'rentabilidad', 'modal-rentabilidad');
            //this.hideModal("modal-rentabilidad");
            break;
  
          default:
            break;
        }
        //}
        //bvModalEvent.preventDefault()
        // Trigger submit handler
        //this.handleSubmit()
      },
      //------------------------------------------
      checkFormValidity() {
        const valid = this.$refs.form.checkValidity();
        this.nameState = valid;
        return valid;
      },
      resetModal() {
        //this.name = ''
        //this.nameState = null
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return;
        }
        // Push the name to submitted names
        //this.submittedNames.push(this.name)
        // Hide the modal manually
        this.$nextTick(() => {
          this.$bvModal.hide("modal-herr");
        });
      },
      showModal(modal, id) {
        console.log(id);
        this.$refs[modal].show();
      },
      hideModal(modal) {
        this.$refs[modal].hide();
      },
      editModal(modal, item) {
        this.editmode = true;
        //this.form.reset();
        this.name = item.name;
        this.$refs[modal].show();
        //$('#addNew').modal('show');
        //this.form.fill(caja);
      },
      aplicarFiltro() {
        //if(this.$gate.isAdmin()){
        let loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: true,
          loader: "dots",
        });
  
        loader.hide();
      },
      resetFiltro() {
        this.filtro.reset();
        this.filtroActivo = false;
        //this.loadUsuariosPos();
      },
      onFiltroChange() {
        this.filtroActivo = true;
      },
      getDate() {
        var currentDate = new Date();
        return (
          currentDate.getFullYear() +
          "-" +
          (currentDate.getMonth() < 9
            ? "0" + (currentDate.getMonth() + 1)
            : currentDate.getMonth() + 1) +
          "-" +
          (currentDate.getDate() < 10
            ? "0" + currentDate.getDate()
            : currentDate.getDate())
        );
      },
      getSelectTienda() {
        this.tiendas.forEach((element) => {
          let data = { value: element.id, text: element.nombre };
          this.selectTienda.push(data);
        });
      },
      actorSeleccionado(item){
        //let actorS = item.beneficiarios.find(i => i.text === item.selPromResponsabilidad);
        console.log(item)
        return  item + "----";
      },
      /*editModal(caja){
          this.editmode = true;
          this.form.reset();
          this.$refs['modal-1'].show();
          //$('#addNew').modal('show');
          this.form.fill(caja);
        },*/
      getHora() {
        var currentDate = new Date();
        var hora = currentDate.getHours();
        var min = currentDate.getMinutes();
        //var seg = currentDate.getSeconds();
        return (
          (hora < 10 ? "0" + hora : hora) + ":" + (min < 10 ? "0" + min : min)
        );
      },
      calculardiferencia(hora_desde = "12:00T12:00") {
        var hora_inicio = hora_desde.split("T")[1];
        hora_inicio = hora_inicio.slice(0, 5);
        //var hora_iniciop = hora_desde;
        var hora_final = this.getHora();
  
        if (hora_desde > hora_final) {
          hora_inicio = hora_final;
          hora_final = hora_desde;
        }
  
        // Expresión regular para comprobar formato
        var formatohora = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
  
        // Si algún valor no tiene formato correcto sale
        if (!(hora_inicio.match(formatohora) && hora_final.match(formatohora))) {
          return;
        }
  
        // Calcula los minutos de cada hora
        var minutos_inicio = hora_inicio
          .split(":")
          .reduce((p, c) => parseInt(p) * 60 + parseInt(c));
        var minutos_final = hora_final
          .split(":")
          .reduce((p, c) => parseInt(p) * 60 + parseInt(c));
  
        // Si la hora final es anterior a la hora inicial sale
        if (minutos_final < minutos_inicio) return;
  
        // Diferencia de minutos
        var diferencia = minutos_final - minutos_inicio;
  
        // Cálculo de horas y minutos de la diferencia
        var horas = Math.floor(diferencia / 60);
        var minutos = diferencia % 60;
  
        return horas + ":" + (minutos < 10 ? "0" : "") + minutos;
      },
      zfill(number, width = 6) {
        var numberOutput = Math.abs(number); /* Valor absoluto del número */
        var length = number.toString().length; /* Largo del número */
        var zero = "0"; /* String de cero */
  
        if (width <= length) {
          if (number < 0) {
            return "-" + numberOutput.toString();
          } else {
            return numberOutput.toString();
          }
        } else {
          if (number < 0) {
            return "-" + zero.repeat(width - length) + numberOutput.toString();
          } else {
            return zero.repeat(width - length) + numberOutput.toString();
          }
        }
      },
      optionsMenu(opcion) {
        let obj = null;
        switch (opcion) {
          case "1":
            obj = this.layout;
            break;
          case "2":
            break;
          case "3":
            break;
          case "4":
            break;
          case "5":
            break;
          case "6":
            break;
          case "7":
            break;
          case "8":
            break;
        }
        return obj;
      },
      removeItem: function (val, i) {
        let actualLayout = null;
        this.$swal({
          title: "Esta Seguro de Eliminar?",
          text: "No podra revertir los cambios!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Si, Procedo a Borrar!",
        }).then((result) => {
          // Send request to the server
          if (result.value) {
            switch (i) {
              case 1:
                actualLayout = this.layout;
                break;
              case 2:
                actualLayout = this.layout2;
                break;
              case 3:
                actualLayout = this.layout3;
                break;
              case 4:
                actualLayout = this.layout4;
                break;
              case 5:
                actualLayout = this.layout5;
                break;
              case 6:
                actualLayout = this.layout6;
                break;
              case 7:
                actualLayout = this.layout7;
                break;
              case 8:
                actualLayout = this.layout8;
                break;
            }
  
            const index = actualLayout.map((item) => item.i).indexOf(val);
            actualLayout.splice(index, 1);
            /*this.form.delete(this.$gate.getApiUrl()+'Qqm/'+id).then(()=>{
                          this.$swal(
                          'Eliminado!',
                          'Registro Borrado.',
                          'success'
                          )
                      Fire.$emit('AfterCreate');
                  }).catch(()=> {
                      this.$swal("Failed!", "There was something wronge.", "warning");
                  });*/
          }
        });
      },
      //Begin metod Drag
      drag: function (e) {
        let parentRect = document
          .getElementById("content")
          .getBoundingClientRect();
        let mouseInGrid = false;
        if (
          mouseXY.x > parentRect.left &&
          mouseXY.x < parentRect.right &&
          mouseXY.y > parentRect.top &&
          mouseXY.y < parentRect.bottom
        ) {
          mouseInGrid = true;
        }
        if (
          mouseInGrid === true &&
          this.layout.findIndex((item) => item.i === "drop") === -1
        ) {
          if (this.layout.length == 0)
            this.layout.push({
              x: (this.layout.length * 2) % (this.colNum || 12),
              y: this.layout.length + (this.colNum || 12), // puts it at the bottom
              w: 1,
              h: 1,
              i: "drop",
              data: { Nombre: "proyecto " + DragPos.i, Proyecto: this.proyecto },
            });
        }
        let index = this.layout.findIndex((item) => item.i === "drop");
        if (index !== -1) {
          try {
            this.$refs.gridlayout.$children[
              this.layout.length
            ].$refs.item.style.display = "none";
          } catch {}
          let el = this.$refs.gridlayout.$children[index];
          el.dragging = {
            top: mouseXY.y - parentRect.top,
            left: mouseXY.x - parentRect.left,
          };
          let new_pos = el.calcXY(
            mouseXY.y - parentRect.top,
            mouseXY.x - parentRect.left
          );
          if (mouseInGrid === true) {
            try {
              this.$refs.gridlayout.dragEvent(
                "dragstart",
                "drop",
                new_pos.x,
                new_pos.y,
                1,
                1
              );
            } catch {}
            DragPos.i = String(index);
            DragPos.x = this.layout[index].x;
            DragPos.y = this.layout[index].y;
          }
          if (mouseInGrid === false) {
            try {
              this.$refs.gridlayout.dragEvent(
                "dragend",
                "drop",
                new_pos.x,
                new_pos.y,
                1,
                1
              );
            } catch {}
            this.layout = this.layout.filter((obj) => obj.i !== "drop");
          }
        }
      },
      dragend: function (e) {
        let parentRect = document
          .getElementById("content")
          .getBoundingClientRect();
        let mouseInGrid = false;
        if (
          mouseXY.x > parentRect.left &&
          mouseXY.x < parentRect.right &&
          mouseXY.y > parentRect.top &&
          mouseXY.y < parentRect.bottom
        ) {
          mouseInGrid = true;
        }
        if (mouseInGrid === true) {
          //alert(`Dropped element props:\n${JSON.stringify(DragPos, ['x', 'y', 'w', 'h'], 2)}`);
          try {
            this.$refs.gridlayout.dragEvent(
              "dragend",
              "drop",
              DragPos.x,
              DragPos.y,
              1,
              1
            );
          } catch {}
          this.layout = this.layout.filter((obj) => obj.i !== "drop");
          // UNCOMMENT below if you want to add a grid-item
          if (this.layout.length == 0)
            this.layout.push({
              x: DragPos.x,
              y: DragPos.y,
              w: 2,
              h: 3.5,
              i: DragPos.i,
              data: { Nombre: "proyecto " + DragPos.i, Proyecto: this.proyecto },
            });
          try {
            this.$refs.gridLayout.dragEvent(
              "dragend",
              DragPos.i,
              DragPos.x,
              DragPos.y,
              1,
              1
            );
          } catch {}
          try {
            this.$refs.gridLayout.$children[
              this.layout.length
            ].$refs.item.style.display = "block";
          } catch {}
        }
      },
      //---------2--------
      drag2: function (e) {
        console.log(e.target.id);
        //let layout = this.optionsMenu(e.target.id);
        let parentRect = document
          .getElementById("content2")
          .getBoundingClientRect();
        let mouseInGrid = false;
        if (
          mouseXY.x > parentRect.left &&
          mouseXY.x < parentRect.right &&
          mouseXY.y > parentRect.top &&
          mouseXY.y < parentRect.bottom
        ) {
          mouseInGrid = true;
        }
        if (
          mouseInGrid === true &&
          this.layout2.findIndex((item) => item.i === "drop") === -1
        ) {
          this.layout2.push({
            x: (this.layout2.length * 2) % (this.colNum || 12),
            y: this.layout2.length + (this.colNum || 12), // puts it at the bottom
            w: 1,
            h: 1,
            i: "drop",
            data: { Nombre: "promotor " + parseInt(DragPos.i)+1, Promotor: this.promotor},
          });
        }
        let index = this.layout2.findIndex((item) => item.i === "drop");
        if (index !== -1) {
          try {
            this.$refs.gridlayout2.$children[
              this.layout2.length
            ].$refs.item.style.display = "none";
          } catch {}
          let el = this.$refs.gridlayout2.$children[index];
          el.dragging = {
            top: mouseXY.y - parentRect.top,
            left: mouseXY.x - parentRect.left,
          };
          let new_pos = el.calcXY(
            mouseXY.y - parentRect.top,
            mouseXY.x - parentRect.left
          );
          if (mouseInGrid === true) {
            try {
              this.$refs.gridlayout2.dragEvent(
                "dragstart",
                "drop",
                new_pos.x,
                new_pos.y,
                1,
                1
              );
            } catch {}
            DragPos.i = String(index);
            DragPos.x = this.layout2[index].x;
            DragPos.y = this.layout2[index].y;
          }
          if (mouseInGrid === false) {
            try {
              this.$refs.gridlayout2.dragEvent(
                "dragend",
                "drop",
                new_pos.x,
                new_pos.y,
                1,
                1
              );
            } catch {}
            this.layout2 = this.layout2.filter((obj) => obj.i !== "drop");
          }
        }
      },
      dragend2: function (e) {
        let parentRect = document
          .getElementById("content2")
          .getBoundingClientRect();
        let mouseInGrid = false;
        if (
          mouseXY.x > parentRect.left &&
          mouseXY.x < parentRect.right &&
          mouseXY.y > parentRect.top &&
          mouseXY.y < parentRect.bottom
        ) {
          mouseInGrid = true;
        }
        if (mouseInGrid === true) {
          //alert(`Dropped element props:\n${JSON.stringify(DragPos, ['x', 'y', 'w', 'h'], 2)}`);
          try {
            this.$refs.gridlayout2.dragEvent(
              "dragend",
              "drop",
              DragPos.x,
              DragPos.y,
              1,
              1
            );
          } catch {}
          this.layout2 = this.layout2.filter((obj) => obj.i !== "drop");
          // UNCOMMENT below if you want to add a grid-item
  
          this.layout2.push({
            x: DragPos.x,
            y: DragPos.y,
            w: 5,
            h: 3,
            i: DragPos.i,
            data: { Nombre: "promotor " + parseInt(DragPos.i)+1, Promotor: this.promotor},
          });
          try {
            this.$refs.gridLayout2.dragEvent(
              "dragend",
              DragPos.i,
              DragPos.x,
              DragPos.y,
              1,
              1
            );
          } catch {}
          try {
            this.$refs.gridLayout2.$children[
              this.layout2.length
            ].$refs.item.style.display = "block";
          } catch {}
        }
      },
      //-----------------
      drag3: function (e) {
        //let layout = this.optionsMenu(e.target.id);
        let parentRect = document
          .getElementById("content3")
          .getBoundingClientRect();
        let mouseInGrid = false;
        if (
          mouseXY.x > parentRect.left &&
          mouseXY.x < parentRect.right &&
          mouseXY.y > parentRect.top &&
          mouseXY.y < parentRect.bottom
        ) {
          mouseInGrid = true;
        }
        if (
          mouseInGrid === true &&
          this.layout3.findIndex((item) => item.i === "drop") === -1
        ) {
          this.layout3.push({
            x: (this.layout3.length * 2) % (this.colNum || 12),
            y: this.layout3.length + (this.colNum || 12), // puts it at the bottom
            w: 1,
            h: 1,
            i: "drop",
            data: { Nombre: "beneficiario " + parseInt(DragPos.i)+1, Beneficiario: this.beneficiario },
          });
        }
        let index = this.layout3.findIndex((item) => item.i === "drop");
        if (index !== -1) {
          try {
            this.$refs.gridlayout3.$children[
              this.layout3.length
            ].$refs.item.style.display = "none";
          } catch {}
          let el = this.$refs.gridlayout3.$children[index];
          el.dragging = {
            top: mouseXY.y - parentRect.top,
            left: mouseXY.x - parentRect.left,
          };
          let new_pos = el.calcXY(
            mouseXY.y - parentRect.top,
            mouseXY.x - parentRect.left
          );
          if (mouseInGrid === true) {
            try {
              this.$refs.gridlayout3.dragEvent(
                "dragstart",
                "drop",
                new_pos.x,
                new_pos.y,
                1,
                1
              );
            } catch {}
            DragPos.i = String(index);
            DragPos.x = this.layout3[index].x;
            DragPos.y = this.layout3[index].y;
          }
          if (mouseInGrid === false) {
            try {
              this.$refs.gridlayout3.dragEvent(
                "dragend",
                "drop",
                new_pos.x,
                new_pos.y,
                1,
                1
              );
            } catch {}
            this.layout3 = this.layout3.filter((obj) => obj.i !== "drop");
          }
        }
      },
      dragend3: function (e) {
        let parentRect = document
          .getElementById("content3")
          .getBoundingClientRect();
        let mouseInGrid = false;
        if (
          mouseXY.x > parentRect.left &&
          mouseXY.x < parentRect.right &&
          mouseXY.y > parentRect.top &&
          mouseXY.y < parentRect.bottom
        ) {
          mouseInGrid = true;
        }
        if (mouseInGrid === true) {
          //alert(`Dropped element props:\n${JSON.stringify(DragPos, ['x', 'y', 'w', 'h'], 2)}`);
          try {
            this.$refs.gridlayout3.dragEvent(
              "dragend",
              "drop",
              DragPos.x,
              DragPos.y,
              1,
              1
            );
          } catch {}
          this.layout3 = this.layout3.filter((obj) => obj.i !== "drop");
          // UNCOMMENT below if you want to add a grid-item
  
          this.layout3.push({
            x: DragPos.x,
            y: DragPos.y,
            w: 5,
            h: 3,
            i: DragPos.i,
            data: { Nombre: "beneficiario " + parseInt(DragPos.i)+1, Beneficiario: this.beneficiario },
          });
          try {
            this.$refs.gridLayout3.dragEvent(
              "dragend",
              DragPos.i,
              DragPos.x,
              DragPos.y,
              1,
              1
            );
          } catch {}
          try {
            this.$refs.gridLayout3.$children[
              this.layout3.length
            ].$refs.item.style.display = "block";
          } catch {}
        }
      },
      //-----------------
      drag4: function (e) {
        //let layout = this.optionsMenu(e.target.id);
        let parentRect = document
          .getElementById("content4")
          .getBoundingClientRect();
        let mouseInGrid = false;
        if (
          mouseXY.x > parentRect.left &&
          mouseXY.x < parentRect.right &&
          mouseXY.y > parentRect.top &&
          mouseXY.y < parentRect.bottom
        ) {
          mouseInGrid = true;
        }
        if (
          mouseInGrid === true &&
          this.layout4.findIndex((item) => item.i === "drop") === -1
        ) {
          this.layout4.push({
            x: (this.layout4.length * 2) % (this.colNum || 12),
            y: this.layout4.length + (this.colNum || 12), // puts it at the bottom
            w: 1,
            h: 1,
            i: "drop",
            data: { Nombre: "responsabilidad " + parseInt(DragPos.i)+1, Responsabilidad: this.responsabilidades },
          });
        }
        let index = this.layout4.findIndex((item) => item.i === "drop");
        if (index !== -1) {
          try {
            this.$refs.gridlayout4.$children[
              this.layout4.length
            ].$refs.item.style.display = "none";
          } catch {}
          let el = this.$refs.gridlayout4.$children[index];
          el.dragging = {
            top: mouseXY.y - parentRect.top,
            left: mouseXY.x - parentRect.left,
          };
          let new_pos = el.calcXY(
            mouseXY.y - parentRect.top,
            mouseXY.x - parentRect.left
          );
          if (mouseInGrid === true) {
            try {
              this.$refs.gridlayout4.dragEvent(
                "dragstart",
                "drop",
                new_pos.x,
                new_pos.y,
                1,
                1
              );
            } catch {}
            DragPos.i = String(index);
            DragPos.x = this.layout4[index].x;
            DragPos.y = this.layout4[index].y;
          }
          if (mouseInGrid === false) {
            try {
              this.$refs.gridlayout4.dragEvent(
                "dragend",
                "drop",
                new_pos.x,
                new_pos.y,
                1,
                1
              );
            } catch {}
            this.layout4 = this.layout4.filter((obj) => obj.i !== "drop");
          }
        }
      },
      dragend4: function (e) {
        let parentRect = document
          .getElementById("content4")
          .getBoundingClientRect();
        let mouseInGrid = false;
        if (
          mouseXY.x > parentRect.left &&
          mouseXY.x < parentRect.right &&
          mouseXY.y > parentRect.top &&
          mouseXY.y < parentRect.bottom
        ) {
          mouseInGrid = true;
        }
        if (mouseInGrid === true) {
          //alert(`Dropped element props:\n${JSON.stringify(DragPos, ['x', 'y', 'w', 'h'], 2)}`);
          try {
            this.$refs.gridlayout4.dragEvent(
              "dragend",
              "drop",
              DragPos.x,
              DragPos.y,
              1,
              1
            );
          } catch {}
          this.layout4 = this.layout4.filter((obj) => obj.i !== "drop");
          // UNCOMMENT below if you want to add a grid-item
  
          this.layout4.push({
            x: DragPos.x,
            y: DragPos.y,
            w: 2.5,
            h: 3,
            i: DragPos.i,
            data: { Nombre: "responsabilidad " + parseInt(DragPos.i)+1, Responsabilidad: this.responsabilidades },
          });
          try {
            this.$refs.gridLayout4.dragEvent(
              "dragend",
              DragPos.i,
              DragPos.x,
              DragPos.y,
              1,
              1
            );
          } catch {}
          try {
            this.$refs.gridLayout4.$children[
              this.layout4.length
            ].$refs.item.style.display = "block";
          } catch {}
        }
      },
      //-----------------
      drag5: function (e) {
        //let layout = this.optionsMenu(e.target.id);
        let parentRect = document
          .getElementById("content5")
          .getBoundingClientRect();
        let mouseInGrid = false;
        if (
          mouseXY.x > parentRect.left &&
          mouseXY.x < parentRect.right &&
          mouseXY.y > parentRect.top &&
          mouseXY.y < parentRect.bottom
        ) {
          mouseInGrid = true;
        }
        if (
          mouseInGrid === true &&
          this.layout5.findIndex((item) => item.i === "drop") === -1
        ) {
          this.layout5.push({
            x: (this.layout5.length * 2) % (this.colNum || 12),
            y: this.layout5.length + (this.colNum || 12), // puts it at the bottom
            w: 1,
            h: 1,
            i: "drop",
            data: { Nombre: "Recurso " + parseInt(DragPos.i)+1, Recurso: this.recurso },
          });
        }
        let index = this.layout5.findIndex((item) => item.i === "drop");
        if (index !== -1) {
          try {
            this.$refs.gridlayout5.$children[
              this.layout5.length
            ].$refs.item.style.display = "none";
          } catch {}
          let el = this.$refs.gridlayout5.$children[index];
          el.dragging = {
            top: mouseXY.y - parentRect.top,
            left: mouseXY.x - parentRect.left,
          };
          let new_pos = el.calcXY(
            mouseXY.y - parentRect.top,
            mouseXY.x - parentRect.left
          );
          if (mouseInGrid === true) {
            try {
              this.$refs.gridlayout5.dragEvent(
                "dragstart",
                "drop",
                new_pos.x,
                new_pos.y,
                1,
                1
              );
            } catch {}
            DragPos.i = String(index);
            DragPos.x = this.layout5[index].x;
            DragPos.y = this.layout5[index].y;
          }
          if (mouseInGrid === false) {
            try {
              this.$refs.gridlayout5.dragEvent(
                "dragend",
                "drop",
                new_pos.x,
                new_pos.y,
                1,
                1
              );
            } catch {}
            this.layout5 = this.layout5.filter((obj) => obj.i !== "drop");
          }
        }
      },
      dragend5: function (e) {
        let parentRect = document
          .getElementById("content5")
          .getBoundingClientRect();
        let mouseInGrid = false;
        if (
          mouseXY.x > parentRect.left &&
          mouseXY.x < parentRect.right &&
          mouseXY.y > parentRect.top &&
          mouseXY.y < parentRect.bottom
        ) {
          mouseInGrid = true;
        }
        if (mouseInGrid === true) {
          //alert(`Dropped element props:\n${JSON.stringify(DragPos, ['x', 'y', 'w', 'h'], 2)}`);
          try {
            this.$refs.gridlayout5.dragEvent(
              "dragend",
              "drop",
              DragPos.x,
              DragPos.y,
              1,
              1
            );
          } catch {}
          this.layout5 = this.layout5.filter((obj) => obj.i !== "drop");
          // UNCOMMENT below if you want to add a grid-item
  
          this.layout5.push({
            x: DragPos.x,
            y: DragPos.y,
            w: 2.5,
            h: 3,
            i: DragPos.i,
            data: { Nombre: "recur. sociales " + parseInt(DragPos.i)+1, Recurso: this.recurso },
          });
          try {
            this.$refs.gridLayout5.dragEvent(
              "dragend",
              DragPos.i,
              DragPos.x,
              DragPos.y,
              1,
              1
            );
          } catch {}
          try {
            this.$refs.gridLayout5.$children[
              this.layout5.length
            ].$refs.item.style.display = "block";
          } catch {}
        }
      },
      //-----------------
      drag6: function (e) {
        //let layout = this.optionsMenu(e.target.id);
        let parentRect = document
          .getElementById("content6")
          .getBoundingClientRect();
        let mouseInGrid = false;
        if (
          mouseXY.x > parentRect.left &&
          mouseXY.x < parentRect.right &&
          mouseXY.y > parentRect.top &&
          mouseXY.y < parentRect.bottom
        ) {
          mouseInGrid = true;
        }
        if (
          mouseInGrid === true &&
          this.layout6.findIndex((item) => item.i === "drop") === -1
        ) {
          this.layout6.push({
            x: (this.layout6.length * 2) % (this.colNum || 12),
            y: this.layout6.length + (this.colNum || 12), // puts it at the bottom
            w: 1,
            h: 1,
            i: "drop",
            data: { Nombre: "mecan. dialogo " + parseInt(DragPos.i+1), Dialogo: this.dialogo },
          });
        }
        let index = this.layout6.findIndex((item) => item.i === "drop");
        if (index !== -1) {
          try {
            this.$refs.gridlayout6.$children[
              this.layout6.length
            ].$refs.item.style.display = "none";
          } catch {}
          let el = this.$refs.gridlayout6.$children[index];
          el.dragging = {
            top: mouseXY.y - parentRect.top,
            left: mouseXY.x - parentRect.left,
          };
          let new_pos = el.calcXY(
            mouseXY.y - parentRect.top,
            mouseXY.x - parentRect.left
          );
          if (mouseInGrid === true) {
            try {
              this.$refs.gridlayout6.dragEvent(
                "dragstart",
                "drop",
                new_pos.x,
                new_pos.y,
                1,
                1
              );
            } catch {}
            DragPos.i = String(index);
            DragPos.x = this.layout6[index].x;
            DragPos.y = this.layout6[index].y;
          }
          if (mouseInGrid === false) {
            try {
              this.$refs.gridlayout6.dragEvent(
                "dragend",
                "drop",
                new_pos.x,
                new_pos.y,
                1,
                1
              );
            } catch {}
            this.layout6 = this.layout6.filter((obj) => obj.i !== "drop");
          }
        }
      },
      dragend6: function (e) {
        let parentRect = document
          .getElementById("content6")
          .getBoundingClientRect();
        let mouseInGrid = false;
        if (
          mouseXY.x > parentRect.left &&
          mouseXY.x < parentRect.right &&
          mouseXY.y > parentRect.top &&
          mouseXY.y < parentRect.bottom
        ) {
          mouseInGrid = true;
        }
        if (mouseInGrid === true) {
          //alert(`Dropped element props:\n${JSON.stringify(DragPos, ['x', 'y', 'w', 'h'], 2)}`);
          try {
            this.$refs.gridlayout6.dragEvent(
              "dragend",
              "drop",
              DragPos.x,
              DragPos.y,
              1,
              1
            );
          } catch {}
          this.layout6 = this.layout6.filter((obj) => obj.i !== "drop");
          // UNCOMMENT below if you want to add a grid-item
  
          this.layout6.push({
            x: DragPos.x,
            y: DragPos.y,
            w: 2.5,
            h: 3,
            i: DragPos.i,
            data: { Nombre: "mecan. dialogo " + parseInt(DragPos.i+1), Dialogo: this.dialogo },
          });
          try {
            this.$refs.gridLayout6.dragEvent(
              "dragend",
              DragPos.i,
              DragPos.x,
              DragPos.y,
              1,
              1
            );
          } catch {}
          try {
            this.$refs.gridLayout6.$children[
              this.layout6.length
            ].$refs.item.style.display = "block";
          } catch {}
        }
      },
      //-----------------
      drag7: function (e) {
        //let layout = this.optionsMenu(e.target.id);
        let parentRect = document
          .getElementById("content7")
          .getBoundingClientRect();
        let mouseInGrid = false;
        if (
          mouseXY.x > parentRect.left &&
          mouseXY.x < parentRect.right &&
          mouseXY.y > parentRect.top &&
          mouseXY.y < parentRect.bottom
        ) {
          mouseInGrid = true;
        }
        if (
          mouseInGrid === true &&
          this.layout7.findIndex((item) => item.i === "drop") === -1
        ) {
          this.layout7.push({
            x: (this.layout7.length * 2) % (this.colNum || 12),
            y: this.layout7.length + (this.colNum || 12), // puts it at the bottom
            w: 1,
            h: 1,
            i: "drop",
            data: { Nombre: "compromiso con la comunidad " + parseInt(DragPos.i)+1, Compromiso: this.compromiso },          
          });
        }
        let index = this.layout7.findIndex((item) => item.i === "drop");
        if (index !== -1) {
          try {
            this.$refs.gridlayout7.$children[
              this.layout7.length
            ].$refs.item.style.display = "none";
          } catch {}
          let el = this.$refs.gridlayout7.$children[index];
          el.dragging = {
            top: mouseXY.y - parentRect.top,
            left: mouseXY.x - parentRect.left,
          };
          let new_pos = el.calcXY(
            mouseXY.y - parentRect.top,
            mouseXY.x - parentRect.left
          );
          if (mouseInGrid === true) {
            try {
              this.$refs.gridlayout7.dragEvent(
                "dragstart",
                "drop",
                new_pos.x,
                new_pos.y,
                1,
                1
              );
            } catch {}
            DragPos.i = String(index);
            DragPos.x = this.layout7[index].x;
            DragPos.y = this.layout7[index].y;
          }
          if (mouseInGrid === false) {
            try {
              this.$refs.gridlayout7.dragEvent(
                "dragend",
                "drop",
                new_pos.x,
                new_pos.y,
                1,
                1
              );
            } catch {}
            this.layout7 = this.layout7.filter((obj) => obj.i !== "drop");
          }
        }
      },
      dragend7: function (e) {
        let parentRect = document
          .getElementById("content7")
          .getBoundingClientRect();
        let mouseInGrid = false;
        if (
          mouseXY.x > parentRect.left &&
          mouseXY.x < parentRect.right &&
          mouseXY.y > parentRect.top &&
          mouseXY.y < parentRect.bottom
        ) {
          mouseInGrid = true;
        }
        if (mouseInGrid === true) {
          //alert(`Dropped element props:\n${JSON.stringify(DragPos, ['x', 'y', 'w', 'h'], 2)}`);
          try {
            this.$refs.gridlayout7.dragEvent(
              "dragend",
              "drop",
              DragPos.x,
              DragPos.y,
              1,
              1
            );
          } catch {}
          this.layout7 = this.layout7.filter((obj) => obj.i !== "drop");
          // UNCOMMENT below if you want to add a grid-item
  
          this.layout7.push({
            x: DragPos.x,
            y: DragPos.y,
            w: 4,
            h: 3,
            i: DragPos.i,
            data: { Nombre: "compromiso con la comunidad " + parseInt(DragPos.i)+1, Compromiso: this.compromiso },
          });
          try {
            this.$refs.gridLayout7.dragEvent(
              "dragend",
              DragPos.i,
              DragPos.x,
              DragPos.y,
              1,
              1
            );
          } catch {}
          try {
            this.$refs.gridLayout7.$children[
              this.layout7.length
            ].$refs.item.style.display = "block";
          } catch {}
        }
      },
      //-----------------
      drag8: function (e) {
        //let layout = this.optionsMenu(e.target.id);
        let parentRect = document
          .getElementById("content8")
          .getBoundingClientRect();
        let mouseInGrid = false;
        if (
          mouseXY.x > parentRect.left &&
          mouseXY.x < parentRect.right &&
          mouseXY.y > parentRect.top &&
          mouseXY.y < parentRect.bottom
        ) {
          mouseInGrid = true;
        }
        if (
          mouseInGrid === true &&
          this.layout8.findIndex((item) => item.i === "drop") === -1
        ) {
          this.layout8.push({
            x: (this.layout8.length * 2) % (this.colNum || 12),
            y: this.layout8.length + (this.colNum || 12), // puts it at the bottom
            w: 1,
            h: 1,
            i: "drop",
            data: { Nombre: "Beneficios " + parseInt(DragPos.i)+1, Rentabilidad: this.rentabilidad },
          });
        }
        let index = this.layout8.findIndex((item) => item.i === "drop");
        if (index !== -1) {
          try {
            this.$refs.gridlayout8.$children[
              this.layout8.length
            ].$refs.item.style.display = "none";
          } catch {}
          let el = this.$refs.gridlayout8.$children[index];
          el.dragging = {
            top: mouseXY.y - parentRect.top,
            left: mouseXY.x - parentRect.left,
          };
          let new_pos = el.calcXY(
            mouseXY.y - parentRect.top,
            mouseXY.x - parentRect.left
          );
          if (mouseInGrid === true) {
            try {
              this.$refs.gridlayout8.dragEvent(
                "dragstart",
                "drop",
                new_pos.x,
                new_pos.y,
                1,
                1
              );
            } catch {}
            DragPos.i = String(index);
            DragPos.x = this.layout8[index].x;
            DragPos.y = this.layout8[index].y;
          }
          if (mouseInGrid === false) {
            try {
              this.$refs.gridlayout8.dragEvent(
                "dragend",
                "drop",
                new_pos.x,
                new_pos.y,
                1,
                1
              );
            } catch {}
            this.layout8 = this.layout8.filter((obj) => obj.i !== "drop");
          }
        }
      },
      dragend8: function (e) {
        let parentRect = document
          .getElementById("content8")
          .getBoundingClientRect();
        let mouseInGrid = false;
        if (
          mouseXY.x > parentRect.left &&
          mouseXY.x < parentRect.right &&
          mouseXY.y > parentRect.top &&
          mouseXY.y < parentRect.bottom
        ) {
          mouseInGrid = true;
        }
        if (mouseInGrid === true) {
          //alert(`Dropped element props:\n${JSON.stringify(DragPos, ['x', 'y', 'w', 'h'], 2)}`);
          try {
            this.$refs.gridlayout8.dragEvent(
              "dragend",
              "drop",
              DragPos.x,
              DragPos.y,
              1,
              1
            );
          } catch {}
          this.layout8 = this.layout8.filter((obj) => obj.i !== "drop");
          // UNCOMMENT below if you want to add a grid-item
  
          this.layout8.push({
            x: DragPos.x,
            y: DragPos.y,
            w: 3,
            h: 3,
            i: DragPos.i,
            data: { Nombre: "Beneficios " + parseInt(DragPos.i)+1, Rentabilidad: this.rentabilidad },
          });
          try {
            this.$refs.gridLayout8.dragEvent(
              "dragend",
              DragPos.i,
              DragPos.x,
              DragPos.y,
              1,
              1
            );
          } catch {}
          try {
            this.$refs.gridLayout8.$children[
              this.layout8.length
            ].$refs.item.style.display = "block";
          } catch {}
        }
      },
      async loadProyecto(){
        if(this.$route.query.hasOwnProperty('id')){
          const proyectoId = this.$route.query.id;
          await axios.get(this.$gate.getApiUrl()+'proyectos/'+proyectoId)
                .then(({ data }) => {
                 
                  this.proyecto.fill(data.proyecto.pj);
                  this.promotor.fill(data.promotor.prj);
                  this.beneficiario.fill(data.beneficiario.bj);
                  this.responsabilidades.fill(data.responsabilidades.rj);
                  data.recurso.rej.actorSocial.push( 
                      { value: data.beneficiario.bj.actor, text: data.beneficiario.bj.actor },
                      { value: data.promotor.prj.actorSocial, text: data.promotor.prj.actorSocial },
                    );
                  this.recurso.fill(data.recurso.rej);
                  this.dialogo.fill(data.dialogo.dj);
                  this.compromiso.fill(data.compromiso.cj);

                  this.selRentabilidadAS = data.rentabilidad.rtj.actorSocial
                  let oRenta = {
                    actorSocial: [
                      { value: data.beneficiario.bj.actor, text: data.beneficiario.bj.actor },
                      { value: data.promotor.prj.actorSocial, text: data.promotor.prj.actorSocial },
                    ],
                    beneficio: data.rentabilidad.rtj.beneficio,
                    comentarios: data.rentabilidad.rtj.comentarios,
                    proyectoId: data.rentabilidad.rtj.proyectoId
                  }
                  this.rentabilidad.fill(oRenta);
                  //layouts
                  console.log("lee rentabilidad")
                  console.log(data.promotor)
                  this.layout.push({ id: 1, x: 0, y: 0, w: 5, h: 3.5, i: "0",
                  data:{Nombre: data.proyecto.p.nombre, Proyecto: data.proyecto.pj} });
                  this.layout2.push({ id: 1, x: 0, y: 0, w: 9, h: 3.5, i: "0",
                  data:{Nombre: data.promotor.pr.nombre, Promotor: data.promotor.prj} });
                  this.layout3.push({ id: 1, x: 0, y: 0, w: 9, h: 3.5, i: "0",
                  data:{Nombre: data.beneficiario.b.nombre, Beneficiario: data.beneficiario.bj} });
                  this.layout4.push({ id: 1, x: 0, y: 0, w: 9, h: 3.5, i: "0",
                  data:{Nombre: data.responsabilidades.r.nombre, Responsabilidad: data.responsabilidades.rj} });
                  this.layout5.push({ id: 1, x: 0, y: 0, w: 9, h: 3.5, i: "0",
                  data:{Nombre: data.recurso.re.nombre, Recurso: data.recurso.rej} });
                  this.layout6.push({ id: 1, x: 0, y: 0, w: 9, h: 3.5, i: "0",
                  data:{Nombre: data.dialogo.d.nombre, Dialogo: data.dialogo.dj} });
                  this.layout7.push({ id: 1, x: 0, y: 0, w: 9, h: 3.5, i: "0",
                  data:{Nombre: data.compromiso.c.nombre, Compromiso: data.compromiso.cj} });
                  this.layout8.push({ id: 1, x: 0, y: 0, w: 9, h: 3.5, i: "0",
                  data:{Nombre: data.rentabilidad.rt.nombre, Rentabilidad: data.rentabilidad.rtj} });

                }).catch( e => {
                  console.log(e)
                    /* si el token es invalido o esta vencido */
                    if (e.response.status == 401) {
                    this.$gate.removeLogin();
                    this.$router.push("/Login");             
                    }
                });
        }else{
          this.$swal(
            '',
            'Falta el Parametro [Id] para cargar un proyecto',
            'error'
          )
          this.$router.push("/proyectos");
        }
      }
    },
    computed: {},
    created() {
      this.loadProyecto();
      Fire.$on('AfterCreate',() => {
               this.loadProyecto();
      });      
    },
    mounted() {
      this.$root.$on("estilo1", () => {
        this.showStyle1 = true;
      });
      this.$root.$on("estilo2", () => {
        this.showStyle1 = false;
      });
  
      document.addEventListener(
        "dragover",
        function (e) {
          mouseXY.x = e.clientX;
          mouseXY.y = e.clientY;
        },
        false
      );
    },
    beforeDestroy() {},
  };
  </script>
  <style src="vue-dialog-drag/dist/vue-dialog-drag.css"></style>
  
  <!-- optional dialog styles, see example -->
  <style src="vue-dialog-drag/dist/dialog-styles.css"></style>
  <style scoped>
  .btnStaticShow {
    float: left;
    /* para mantener visible un elemento en todo momento aunque se haga scroll en la página */
    position: fixed;
    overflow: hidden;
    text-align: center;
    width: 5%;
    padding: 4px;
  }
  .btnStaticHiden {
    float: left;
    /* para mantener visible un elemento en todo momento aunque se haga scroll en la página */
    position: fixed;
    overflow: hidden;
    text-align: center;
    width: 85px;
    padding: 4px;
  }
  .remove {
    color: #FFF;
    font-weight: 700;
      position: absolute;
      right: 2px;
      top: 0;
      cursor: pointer;
  }
  
  .textb{
    font-weight: 700;
    text-transform: uppercase;
    color: #FFF !important;
  }
  /** */
  .vue-grid-layout {
    background: #eee;
  }
  .vue-grid-item:not(.vue-grid-placeholder) {
    background: #ccc;
    border: 1px solid black;
  }
  .vue-grid-item .resizing {
    opacity: 0.9;
  }
  .vue-grid-item .static {
    background: #cce;
  }
  .vue-grid-item .text {
    font-size: 12px;
    text-align: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    height: 100%;
    width: 100%;
    color: black;
  }
  .list-group-itemm {
    position: relative !important;
    display: block !important;
    padding-top: 6px !important;
    padding-right: 23px !important;
    padding-bottom: 5px !important;
    padding-left: 23px !important;
    background-color: #fff !important;
    border: 1px solid #e9ecef !important;
  }
  .style1 {
    background-color: blue !important;
  }
  .style2 {
    background-color: blue !important;
  }
  .style3 {
    background-color: green !important;
  }
  .style4 {
    background-color: green !important;
  }
  .style5 {
    background-color: red !important;
  }
  .style6 {
    background-color: red !important;
  }
  .style7 {
    background-color: cornflowerblue !important;
  }
  .style8 {
    background-color: cornflowerblue !important;
  }
  .style9 {
    background-color: #F8CBA6 !important;
  }
  .style10 {
    background-color: #F8CBA6 !important;
  }
  .style11 {
    background-color: violet !important;
  }
  .style12 {
    background-color: violet !important;
  }
  .style13 {
    background-color: aqua !important;
  }
  .style14 {
    background-color: aqua !important;
  }
  .style15 {
    background-color: teal !important;
  }
  .style16 {
    background-color: teal !important;
  }
  .vue-grid-item .no-drag {
    height: 100%;
    width: 100%;
  }
  .vue-grid-item .minMax {
    font-size: 12px;
  }
  .vue-grid-item .add {
    cursor: pointer;
  }
  .vue-draggable-handle {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 0;
    left: 0;
    background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10'><circle cx='5' cy='5' r='5' fill='#999999'/></svg>")
      no-repeat;
    background-position: bottom right;
    padding: 0 8px 8px 0;
    background-repeat: no-repeat;
    background-origin: content-box;
    box-sizing: border-box;
    cursor: pointer;
  }
  .layoutJSON {
    background: #ddd;
    border: 1px solid black;
    margin-top: 10px;
    padding: 10px;
  }
  .columns {
    -moz-columns: 120px;
    -webkit-columns: 120px;
    columns: 120px;
  }
  
  .filler {
    width: 100%;
    height: 100%;
    display: inline-block;
    position: absolute;
  }
  
  .hands {
    cursor: pointer;
  }
  .headt td {
    min-width: 235px;
    height: 100px;
  }
  
  .bordes {
    border-radius: 15px;
  }
  .cellbackgr {
    background: #c0c0c0;
  }
  .statscard {
    font-size: 13px;
  }
  .fondotasa {
    background: #f5f5f5;
    font-weight: bold;
  }
  .detallefactura {
    font-size: 0.8125rem;
    white-space: nowrap;
  }
  .bckgmontobs {
    background: #e2e6e7;
    font-weight: bold;
  }
  .ocultar {
    display: none;
  }
  
  .fa-chevron:before {
    content: "\f054"; /*right*/
  }
  .in > .fa-chevron:before {
    content: "\f078"; /*down*/
  }
  .vue-grid-item {
    background: red;
    opacity: 0.5;
    transition-duration: 100ms;
  }
  </style>
  